import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
const cases = [{
  name: 'Laura, 41',
  context: 'Oficina + cero tiempo',
  problem: 'A las 16:00 estaba fuera, dulce "sí o sí".',
  adjustment: 'Comida 40/30/30 + micro-ajuste fijo (yogur griego + nueces).',
  result: 'Menos antojo y tarde más estable en la primera semana.'
}, {
  name: 'Ana, 35',
  context: 'Teletrabajo + picoteo',
  problem: '"Como sano" pero a media tarde me entra ansiedad.',
  adjustment: 'Carbo inteligente con proteína y fibra; orden de bocado.',
  result: 'Menos montaña rusa y más foco.'
}, {
  name: 'Marta, 48',
  context: 'Carga mental + cenas tardías',
  problem: 'Llega muerta, cena fuerte, duerme peor y repite el ciclo.',
  adjustment: 'Cena inteligente + micro-ajuste temprano para no llegar en modo ataque.',
  result: 'Tarde-noche más llevadera y menos pesadez.'
}];
export function CaseStudies() {
  return <Section className="bg-white" data-id="element-46">
      <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-47">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2c4a2c] mb-3" data-id="element-48">
          Ejemplos reales (para que lo visualices)
        </h2>
        <p className="text-lg text-[#5a5a5a]" data-id="element-49">
          Ejemplos representativos de cómo se aplica el sistema en vida real.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-50">
        {cases.map((item, index) => <div key={index} className="bg-[#faf8f5] rounded-2xl p-6 border border-[#2c4a2c]/5 hover:shadow-lg transition-shadow" data-id="element-51">
            <div className="mb-4 pb-3 border-b border-[#2c4a2c]/10" data-id="element-52">
              <h3 className="text-lg font-bold text-[#2c4a2c]" data-id="element-53">{item.name}</h3>
              <p className="text-sm text-[#c45d3a] font-medium" data-id="element-54">
                {item.context}
              </p>
            </div>

            <div className="space-y-3" data-id="element-55">
              <div data-id="element-56">
                <p className="text-xs font-bold text-[#5a5a5a] uppercase tracking-wider mb-1" data-id="element-57">
                  Problema
                </p>
                <p className="text-[#2c4a2c] text-sm" data-id="element-58">{item.problem}</p>
              </div>
              <div data-id="element-59">
                <p className="text-xs font-bold text-[#5a5a5a] uppercase tracking-wider mb-1" data-id="element-60">
                  Ajuste
                </p>
                <p className="text-[#2c4a2c] text-sm" data-id="element-61">{item.adjustment}</p>
              </div>
              <div className="bg-[#d4a853]/10 -mx-3 p-3 rounded-lg mt-2" data-id="element-62">
                <p className="text-xs font-bold text-[#d4a853] uppercase tracking-wider mb-1" data-id="element-63">
                  Resultado
                </p>
                <p className="text-[#2c4a2c] font-medium text-sm" data-id="element-64">
                  {item.result}
                </p>
              </div>
            </div>
          </div>)}
      </div>

      <div className="text-center" data-id="element-65">
        <Button variant="outline" data-id="element-66">Quiero aplicarlo a mi caso</Button>
        <p className="mt-2 text-sm text-[#5a5a5a]" data-id="element-67">
          Sin promesas mágicas. Con estructura repetible.
        </p>
      </div>
    </Section>;
}